import { render, staticRenderFns } from "./scheduleClassesWeek.vue?vue&type=template&id=578272da&scoped=true"
import script from "./scheduleClassesWeek.vue?vue&type=script&lang=js"
export * from "./scheduleClassesWeek.vue?vue&type=script&lang=js"
import style0 from "./scheduleClassesWeek.vue?vue&type=style&index=0&id=578272da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578272da",
  null
  
)

export default component.exports